import { useSelector } from 'react-redux';
import FJImageExtenderLeft from '../view/FJImageExtenderLeft';
import { useDispatch } from 'react-redux';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';
import { useMemo } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJImageExtenderLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const taskStatus = useSelector(state => state.common.taskStatus);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const generateNumber = useSelector(state => state.imageExtender.generateNumber);

    const generate = () => {
        dispatch(FJActionImageExtender.generateAction());
    };

    const useCredit = useMemo(() => {
        return 2 * generateNumber;
    }, [generateNumber]);

    return (
        <FJImageExtenderLeft
            generate={generate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            useCredit={useCredit}
            creditNumber={creditNumber}
            isProjectLoading={isProjectLoading}
        />
    );
};

export default FJImageExtenderLeftContainer;
